// Common utils used by two formats when produce a preview data
import Enums from 'utils/EnumsManager';
import { toTimezone } from 'utils/dateTimeUtils';
import moment from 'moment';

const { FieldTypes, DROPZONES } = Enums;
const {
  DateOnly,
  DateTime,
  Email,
  LongText,
  Lookup,
  NumberInput,
  PickList,
  TextInput,
} = FieldTypes;
const { GROUPS, OTHERS, AGGREGATES } = DROPZONES;


/**
 * Cell renderers
 * @description: The followings are renderers for different types.
 */

const getRandomStr = (length = 5) => Math.random().toString(36).substring(2, 2 + length);
const renderEmail = () => `${getRandomStr(8)}@gmail.com`;
const renderDataTimeValue = (isTime) => {
  const now = moment().format('YYYY-MM-DD hh:mm:ss');
  return toTimezone(now, isTime);
};
const renderNumber = () => {
  const num = Math.random() * 100;
  return num.toFixed(2);
};
// Cell renderers ends


const calcValueByType = (type) => {
  switch (type) {
    case DateOnly:
    case DateTime:
      return renderDataTimeValue(type === DateTime);
    case Email:
      return renderEmail();
    case NumberInput:
      return renderNumber();
    case LongText:
    case TextInput:
    case Lookup:
    case PickList:
      return getRandomStr(10);
    default:
      console.warn('No supported type has been found.');
      return null;
  }
};

export {
  calcValueByType,
};



// WEBPACK FOOTER //
// ./src/views/ReportPreview/utils/common.js